// Excent opera la misma base de conocimiento bajo dos entidades:
//   - Seychelles    -> excent.capital
//   - Saint Vincent -> excentcapital.com
//
// El contenido de los artículos (Article.json) está escrito con el dominio de
// Seychelles. Igual que el resto de la app (ver translates/config.js, menu.jsx,
// Notifications.jsx), detectamos la entidad en runtime por hostname y, cuando
// estamos en Saint Vincent, mostramos el dominio correspondiente.
//
// El swap es solo de presentación: api.excent.capital -> api.excentcapital.com,
// app.excent.capital -> app.excentcapital.com, support@excent.capital ->
// support@excentcapital.com. No matchea "excentcapital.com" porque ese token no
// contiene el punto entre "excent" y "capital".
const SVG_HOSTNAME = "excentcapital.com";
const SEY_DOMAIN = /excent\.capital/g;

export const isSaintVincent = () =>
  typeof window !== "undefined" &&
  window.location.hostname.includes(SVG_HOSTNAME);

export const localizeDomain = (text) => {
  if (typeof text !== "string" || !isSaintVincent()) return text;
  return text.replace(SEY_DOMAIN, SVG_HOSTNAME);
};

export default localizeDomain;
